import { useNavigate } from "react-router-dom";
import Components from "../../components";
import settings from "./settings";

const Account = ({ data, dataSetter }) => {
  const navigate = useNavigate();

  const handleAccountDetail = () => navigate("/account/detail");
  const handleAddresses = () => navigate("/account/addresses");
  const handleFavorites = () => navigate("/favorites");
  const handleOrders = () => navigate("/account/orders");
  const handleLanguage = () => navigate("/account/language");
  const handleAgreements = () => navigate("/account/agreements");
  const handleEdit = () => navigate("/account/detail");

  const confirmLogout = () => {
    localStorage.removeItem("accessToken");
    sessionStorage.removeItem("accessToken");
    dataSetter({ key: "customer", value: {} });
    navigate("/welcome");
  };
  return (
    <div>
      <Components.AccountMenu
        extendedSettings={settings}
        id="account-menu"
        label="Account"
        data={data}
        dataSetter={dataSetter}
        handleAccountDetail={handleAccountDetail}
        handleAddresses={handleAddresses}
        handleFavorites={handleFavorites}
        handleOrders={handleOrders}
        handleLanguage={handleLanguage}
        handleAgreements={handleAgreements}
        confirmLogout={confirmLogout}
        handleEdit={handleEdit}
      />
    </div>
  );
};
export default Account;
